/** Semi-automatic (sin autoblocking). El ID va en data-cmp-cdid, no en el path. */
const CMP_SCRIPT = {
  key: 'consentmanager',
  src: 'https://cdn.consentmanager.net/delivery/js/semiautomatic.min.js',
  type: 'text/javascript',
  'data-cmp-ab': '1',
  'data-cmp-cdid': 'd9c20897e2443',
  'data-cmp-host': 'a.delivery.consentmanager.net',
  'data-cmp-cdn': 'cdn.consentmanager.net',
  'data-cmp-codesrc': '0'
} as const

export default defineNuxtPlugin(() => {
  const route = useRoute()
  const config = useRuntimeConfig()
  const cookiesDisabled = config.public.DISABLE_COOKIES === true

  useHead({
    script: computed(() => {
      if (cookiesDisabled) {
        return []
      }
      return [CMP_SCRIPT]
    }),
    style: computed(() => {
      if (cookiesDisabled) {
        return []
      }
      return [{
        key: 'cmp-ui-suppressed-style',
        innerHTML: CMP_UI_SUPPRESSED_CSS
      }]
    })
  })

  if (!import.meta.client || cookiesDisabled) {
    return
  }

  watch(
    () => route.path,
    (path, previousPath) => {
      if (isCmpSuppressedPath(path)) {
        hideConsentManagerUi()
        return
      }

      const leftHidden = previousPath !== undefined && isCmpSuppressedPath(previousPath)
      if (leftHidden) {
        restoreConsentManagerUi()
      }
    },
    { immediate: true }
  )
})
